import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReportDropDown from '../../components/reportDropDown.jsx';
import {systemTypeNamesFormat, reportDateFormat, groundLevelsFormat} from 'helpers/constants.jsx';
import {countries, dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import events from 'lib/events';
import EditableDatePicker from 'components/forms/editableDatePicker';

let sanitizer = [];
let accountStatus = [];

const defaultDateTo = new Date();
const defaultDateFrom = new Date('01/01/1986');

class SystemOptions extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    dealer: PropTypes.object,
  };

  state = {
    accountStatus: 0,
    dateFrom: defaultDateFrom,
    dateTo: defaultDateTo,
    groundLevel: 'N',
    sanitazer: 0,
    store: 0,
    systemType: 0,
  };

  componentWillMount() {
    let {formatMessage} = this.props.intl;

    sanitizer = [
      {value: 0, label: formatMessage({id: 'general.all.sanitizer.types'})},
      {value: 1, label: formatMessage({id: 'general.bromine.pool'})},
      {value: 2, label: formatMessage({id: 'general.chlorine.pool'})},
      {value: 3, label: formatMessage({id: 'general.soft.swim'})},
      {value: 5, label: formatMessage({id: 'general.chlorine.spa'})},
      {value: 6, label: formatMessage({id: 'general.bromine.spa'})},
      {value: 7, label: formatMessage({id: 'general.mineral.springs'})},
      {value: 8, label: formatMessage({id: 'general.soft.soak.biguanide'})},
      {value: 12, label: formatMessage({id: 'general.salt.pool'})},
      {value: 13, label: formatMessage({id: 'general.salt.spa'})},
    ];

    if (this.props.dealer && this.props.dealer.country === countries.CA) {
      sanitizer = sanitizer
        .filter(x => x.value !== 8 && x.value !== 3)
        .concat([
          {value: 14, label: formatMessage({id: 'general.synergy.pool'})},
          {value: 15, label: formatMessage({id: 'general.synergy.spa'})},
        ]);
    }

    accountStatus = [
      {value: 0, label: formatMessage({id: 'general.all'})},
      {value: 1, label: formatMessage({id: 'general.active'})},
      {value: 2, label: formatMessage({id: 'general.inactive'})},
    ];
  }

  updateData = () => {
    this.props.updateReportData(
      moment(this.state.dateFrom).format(dateTimeFormats.numeralDate),
      moment(this.state.dateTo).format(dateTimeFormats.numeralDate),
      this.state.store === 0 ? null : this.state.store,
      this.state.systemType === 0 ? null : this.state.systemType,
      this.state.groundLevel === 'N' ? null : this.state.groundLevel,
      this.state.sanitazer === 0 ? null : this.state.sanitazer,
      this.accountStatus === 0 ? null : this.state.accountStatus,
    );
  };

  updateFilters = (data) => {
    if (data.key === 'dateFrom') {
      if (this.validateDates(data.value, this.state.dateTo)) {
        this.setState({
          dateFrom: data.value,
        });
      }
    } else if (data.key === 'dateTo') {
      if (this.validateDates(this.state.dateFrom, data.value)) {
        this.setState({
          dateTo: data.value,
        });
      }
    } else {
      this.setState({
        accountStatus: 0,
        dateFrom: defaultDateFrom,
        dateTo: defaultDateTo,
        groundLevel: 'N',
        sanitazer: 0,
        store: 0,
        systemType: 0,
      });
    }
  };

  validateDates = (dateFrom, dateTo) => {
    if (moment(dateFrom).isAfter(dateTo)) {
      events.publish('error.user', {
        message: this.props.intl.formatMessage({id: 'general.error.invalid.dates'}),
        key: 'invalidDates',
      });
      return false;
    }
    return true;
  };

  render() {

    let stores = [];
    let systemTypes = [];
    let groundLevelList = [];
    let {formatMessage} = this.props.intl;
    let systemTypeNames = systemTypeNamesFormat(formatMessage);
    let groundLevels = groundLevelsFormat(formatMessage);

    if (this.props.branches !== null && this.props.branches !== undefined && this.props.branches.length > 0) {
      var obj = this.props.branches;

      stores = Object.keys(obj).map(function(key) { return {value: obj[key].id, label: obj[key].name}; });

      stores.unshift({value: 0, label: formatMessage({id: 'general.all.stores'})});
    }

    systemTypes = Object.keys(systemTypeNames).map(function(key) { return {value: key, label: systemTypeNames[key]}; });
    systemTypes.unshift({value: 0, label: formatMessage({id: 'general.all.systems'})});

    groundLevelList = Object.keys(groundLevels).map(function(key) { return {value: key, label: groundLevels[key]}; });
    groundLevelList.unshift({value: 'N', label: formatMessage({id: 'general.all'})});

    return (
      <div className="report-options" >
        <div className="top-title-bar" >
          <FormattedMessage id="general.report.options" />
        </div>
        <div className="select-options container-fluid">
          <div className="row">
            <div className="col-sm-3">
              <div className='form-group'>
                <label><FormattedMessage id="general.date.from" /></label>
                <EditableDatePicker
                  onChange={this.updateFilters}
                  dataKey='dateFrom'
                  value={this.state.dateFrom}
                  maxDate={moment(this.state.dateTo).clone().subtract(1, 'days')}
                  editMode={true}
                  dateFormat={reportDateFormat} />
              </div>
            </div>
            <div className="col-sm-3">
              <div className='form-group'>
                <label><FormattedMessage id="general.date.to" /></label>
                <EditableDatePicker
                  onChange={this.updateFilters}
                  dataKey='dateTo'
                  value={this.state.dateTo}
                  minDate={moment(this.state.dateFrom).clone()}
                  maxDate={moment()}
                  editMode={true}
                  dateFormat={reportDateFormat} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <ReportDropDown value={this.state.store} label={formatMessage({id: 'general.store'})}
                onChange={((e) => {
                  this.setState({store: e.target.value});
                })}
                options={stores} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.systemType} label={formatMessage({id: 'general.system.type'})}
                onChange={((e) => {
                  this.setState({systemType: e.target.value});
                })}
                options={systemTypes} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.groundLevel} label={formatMessage({id: 'general.ground.level'})}
                onChange={((e) => {
                  this.setState({groundLevel: e.target.value});
                })}
                options={groundLevelList} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.sanitazer} label={formatMessage({id: 'general.sanitizer'})}
                onChange={((e) => {
                  this.setState({sanitazer: e.target.value});
                })}
                options={sanitizer} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.accountStatus} label={formatMessage({id: 'general.account.status'})}
                onChange={((e) => {
                  this.setState({accountStatus: e.target.value});
                })}
                options={accountStatus} />
            </div>
          </div>
        </div>
        <div className="manage-options">
          <div className="col-sm-12 button-group">
            <a className="reset-button pull-right" onClick={this.updateFilters}><FormattedMessage id="general.reset" /></a>
            <a className="btn btn-primary pull-right" onClick={this.updateData}><FormattedMessage id="reports.update.summary" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SystemOptions);
